import React from 'react'
import {Icon} from '@chakra-ui/react'

const BoxIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                d="M9.5899 32.7646L6.501 31.267C6.01723 31.0324 5.43491 31.2344 5.20035 31.7182C4.9658 32.202 5.16783 32.7843 5.6516 33.0188L8.7405 34.5165C9.22427 34.751 9.80658 34.549 10.0411 34.0652C10.2757 33.5815 10.0737 32.9992 9.5899 32.7646Z"
                fill="currentColor"
            />
            <path
                d="M6.50609 27.9933L12.4031 30.895C12.8855 31.1324 13.0841 31.7159 12.8467 32.1983C12.6094 32.6807 12.0259 32.8793 11.5435 32.6419L5.6465 29.7402C5.16411 29.5029 4.96547 28.9194 5.20284 28.437C5.44021 27.9546 6.0237 27.756 6.50609 27.9933Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46.363 36.7302V11.5586L46.3627 11.5263C46.3563 11.2601 46.2464 11.0293 46.0777 10.8618C46.0052 10.7894 45.92 10.7273 45.8232 10.6791L24.5753 0.102006C24.3021 -0.0340019 23.9809 -0.0340019 23.7077 0.102006L2.45979 10.6791C2.33945 10.7391 2.23694 10.8205 2.15462 10.9165C2.03574 11.0541 1.95379 11.2268 1.92854 11.4222C1.9216 11.474 1.9188 11.5265 1.92032 11.5793V36.7302C1.92032 37.1033 2.13355 37.4435 2.46928 37.6062L23.7172 47.9026C23.9853 48.0325 24.2981 48.0325 24.5662 47.9026L45.8141 37.6062C46.1498 37.4435 46.363 37.1033 46.363 36.7302ZM24.1417 20.7656L5.10139 11.539L11.8982 8.15559L30.8631 17.5085L24.1417 20.7656ZM25.1152 22.4573L31.9667 19.1372V25.9662C31.9667 26.6868 32.7225 27.1577 33.3693 26.84L38.5175 24.3118C38.8507 24.1482 39.0618 23.8092 39.0618 23.438V15.699L44.4161 13.1045V36.1202L25.1152 45.4731V22.4573ZM23.1682 22.4573V45.4731L3.86727 36.1202V13.1045L23.1682 22.4573ZM37.1149 22.8315V16.6425L33.9136 18.1937V24.4036L37.1149 22.8315ZM33.0833 16.4326L36.338 14.8555L17.3874 5.42307L14.0888 7.0651L33.0833 16.4326ZM43.1818 11.5391L38.5513 13.783L38.5221 13.7678L19.5719 4.33561L24.1415 2.06089L43.1818 11.5391Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default BoxIcon
